import API from "Classes/Api";
import {
  ApiGetCallParams,
  ApiPutCallParams,
  ApiPostCallParams,
  ApiDeleteCallParams,
} from "Classes/ApiCallParams";

class CustomQueryService extends API {
  async lookupCustomQueries({ clientId }) {
    const result = await super.call(
      new ApiGetCallParams({
        action: `/v2/clients/${clientId}/custom-queries/lookup`,
        headers: { ...API.getAuthHeaders() },
      })
    );
    return result;
  }

  async getCustomQueries({ clientId }) {
    const result = await super.call(
      new ApiGetCallParams({
        action: `/v2/clients/${clientId}/custom-queries`,
        headers: { ...API.getAuthHeaders() },
      })
    );
    return result;
  }

  async createCustomQuery({ clientId, payload }) {
    const result = await super.call(
      new ApiPostCallParams({
        action: `/v2/clients/${clientId}/custom-queries`,
        headers: { ...API.getAuthHeaders() },
        body: payload,
        failureMessage: "Failed to create custom query",
      })
    );
    return result;
  }

  async getCustomQuery({ clientId, customQueryId }) {
    const result = await super.call(
      new ApiGetCallParams({
        action: `/v2/clients/${clientId}/custom-queries/${customQueryId}`,
        headers: { ...API.getAuthHeaders() },
      })
    );
    return result;
  }

  async updateCustomQuery({ clientId, customQueryId, payload }) {
    const result = await super.call(
      new ApiPutCallParams({
        action: `/v2/clients/${clientId}/custom-queries/${customQueryId}`,
        headers: { ...API.getAuthHeaders() },
        body: payload,
      })
    );
    return result;
  }

  async deleteCustomQuery({ clientId, customQueryId }) {
    const result = await super.call(
      new ApiDeleteCallParams({
        action: `/v2/clients/${clientId}/custom-queries/${customQueryId}`,
        headers: { ...API.getAuthHeaders() },
      })
    );
    return result;
  }

  async getCustomQueryResult({ clientId, customQueryId }) {
    const result = await super.call(
      new ApiGetCallParams({
        action: `/v2/clients/${clientId}/custom-queries/${customQueryId}/result`,
        headers: { ...API.getAuthHeaders() },
      })
    );
    return result;
  }
}

const instance = new CustomQueryService();
export default instance;
